const EditItemModal = ({ show, onClose, itemData, onChange,full_Item_Detail, onSave }) => {
    if (!show || !itemData) return null;
  
    const handleInput = (e) => {
      const { name, value } = e.target;
      onChange({ ...itemData, [name]: value });
    };


    
  
    return (
      <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
        <div className="modal-dialog modal-dialog-centered modal-lg" >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit Item</h5>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-6">
                  <div className="mb-2">
                <label style={{ fontSize: '0.8rem' }}>Item Name</label>
                <input className="form-control" style={{ fontSize: '0.8rem' }} type="text" readOnly name="accepted_qty" value={full_Item_Detail.item_name} />
              </div></div>
                <div className="col-6">
                <div className="mb-2">
                <label style={{ fontSize: '0.8rem' }}>Item Code</label>
                <input className="form-control" style={{ fontSize: '0.8rem' }} type="text" readOnly name="rejected_qty" value={full_Item_Detail.item_code} />
              </div>
                </div>
            </div>
              <div className="row">
                <div className="col-6">
                  <div className="mb-2">
                <label style={{ fontSize: '0.8rem' }}>Rate</label>
                <input className="form-control" style={{ fontSize: '0.8rem' }} type="text" readOnly name="accepted_qty" value={full_Item_Detail.rate} />
              </div></div>
                <div className="col-6">
                <div className="mb-2">
                <label style={{ fontSize: '0.8rem' }}>Total Amount</label>
                <input className="form-control" style={{ fontSize: '0.8rem' }} type="text" name="rejected_qty" readOnly value={full_Item_Detail.rate*full_Item_Detail.qty}  />
              </div>
                </div>
            </div>


            <div className="row">
                <div className="col-6">
                  <div className="mb-2">
                <label style={{ fontSize: '0.8rem' }}>UOM</label>
                <input className="form-control" style={{ fontSize: '0.8rem' }} type="text" readOnly name="accepted_qty" value={full_Item_Detail.uom} />
              </div></div>
                <div className="col-6">
                <div className="mb-2">
                <label style={{ fontSize: '0.8rem' }}>Total Qty</label>
                <input className="form-control" style={{ fontSize: '0.8rem' }} type="text" name="rejected_qty" readOnly value={full_Item_Detail.qty} />
              </div>
                </div>
            </div>

            
              <div className="row">
                <div className="col-6">
                  <div className="mb-2">
                <label style={{ fontSize: '0.8rem' }}>Accepted Qty</label>
                <input className="form-control" style={{ fontSize: '0.8rem' }} type="number" name="accepted_qty" value={itemData.accepted_qty} onChange={handleInput} />
              </div></div>
                <div className="col-6">
                <div className="mb-2">
                <label style={{ fontSize: '0.8rem' }}>Rejected Qty</label>
                <input className="form-control" style={{ fontSize: '0.8rem' }} type="number" name="rejected_qty" value={itemData.rejected_qty} onChange={handleInput} />
              </div>
                </div>
            </div>



            <div className="row">
               


                <div className="col-6">
                <div className="mb-2">
                <label style={{ fontSize: '0.8rem' }}>Manufacturing Date</label>
                <input className="form-control" style={{ fontSize: '0.8rem' }} type="date" name="manufacturing_date" value={itemData.manufacturing_date} onChange={handleInput} />
              </div>
                </div>

                
                <div className="col-6">
                <div className="mb-2">
                <label style={{ fontSize: '0.8rem' }}>Expiry Date</label>
                <input className="form-control" style={{ fontSize: '0.8rem' }} type="date" name="expiry_date" value={itemData.expiry_date} onChange={handleInput} />
              </div>
                 </div>
            </div>
              

            <div className="row">
                <div className="col-6">
                <div className="mb-2">
                <label style={{ fontSize: '0.8rem' }}>Batch No.</label>
                <input 
  className="form-control" 
  style={{ fontSize: '0.8rem' }} 
  type="text" 
  name="batch_no" 
  value={itemData.batch_no || ""} 
  onChange={handleInput} 
/>

              </div>
                </div>
              </div>


            <div className="row">
  <div className="col-6">
    <div className="mb-2">
      <label style={{ fontSize: '0.8rem' }}>Serial No.   </label>
      {Array.from({ length: Number(full_Item_Detail.qty) || 0 }).map((_, index) => (
        <input
          key={index}
          type="text"
          className="form-control mb-2"
          style={{ fontSize: '0.8rem' }}
          value={itemData.serial_numbers?.[index] || ""}
          onChange={(e) => {
            const updatedSerials = [...(itemData.serial_numbers || [])];
            updatedSerials[index] = e.target.value;
            onChange({ ...itemData, serial_numbers: updatedSerials });
          }}
        />
      ))}
    </div>
  </div>
</div>



{/* 
              <div className="row">
                <div className="col-6">
                <div className="mb-2">
                <label style={{ fontSize: '0.8rem' }}>Serial No. </label>
                   <textarea className="form-control" name="" id="" cols="30" rows="7"></textarea>
                   </div>
                </div>
              </div> */}


            
             
              
             
            </div>
            <div className="modal-footer">
            <p style={{ textDecoration: "none", cursor: "pointer" }} className="custom-btn-00989 m-0" onClick={onSave}> Save </p>
            </div>
          </div>
        </div>
      </div>
    );
  };
  
  export default EditItemModal;
  